/* eslint-disable camelcase */
import { tokenStorage } from '@/shared/storage-service';
import {
  login,
  guestin,
  logout,
  refresh,
  confirmRegisterEmail,
  validRegistrationToken,
  validateSecurityCode,
  confirmUserEmail,
  validateTempToken,
  validateSecurityAnswer,
  fetchUserSecurityQuestions,
  lockUser,
  updateUserEmail,
} from './services/auth-api';

import {
  fetchLoggedUser,
  getUserById,
  guestPermission,
  userPermission,
} from './services/auth-user-api';
import { getContactType } from './services/tms-api';

export const AUTH_INIT = 'auth/INIT';
export const SET_LOGGED_USER = 'auth/SET_LOGGED_USER';
export const SET_TOKENS = 'auth/SET_TOKENS';
export const SET_CONFIRMED_USER_NAME = 'auth/SET_CONFIRMED_USER_NAME';
export const SET_CONFIRMED_USER = 'auth/SET_CONFIRMED_USER';

export const SIGN_USER_IN = 'auth/SIGN_USER_IN';
export const SIGN_GUEST_IN = 'auth/SIGN_GUEST_IN';
export const FETCH_LOGGED_USER = 'auth/FETCH_LOGGED_USER';
export const SIGN_USER_OUT = 'auth/SIGN_USER_OUT';
export const CONFIRM_REGISTER_USER_EMAIL = 'auth/CONFIRM_REGISTER_USER_EMAIL';
export const CONFIRM_USER_EMAIL = 'auth/CONFIRM_USER_EMAIL';
export const REFRESH_TOKENS = 'auth/REFRESH_TOKENS';
export const VALIDATE_REGISTERATION_TOKEN = 'auth/VALIDATE_REGISTERATION_TOKEN';
export const SET_REGISTER_USER_INFO = 'auth/SET_REGISTER_USER_INFO';

export const FETCH_USER_SECURITY_QUESTIONS = 'auth/FETCH_USER_SECURITY_QUESTIONS';
export const SET_USER_SECURITY_QUESTIONS = 'auth/SET_USER_SECURITY_QUESTIONS';
export const SET_FORCE_SECURITY_QUESTION_CHANGE = 'auth/SET_FORCE_SECURITY_QUESTION_CHANGE';
export const VALIDATE_TEMP_TOKEN = 'auth/VALIDATE_TEMP_TOKEN';
export const VALIDATE_SECURITY_CODE = 'auth/VALIDATE_SECURITY_CODE';
export const SECURITY_CODE_RESPONSE = 'auth/SECURITY_CODE_RESPONSE';
export const VALIDATE_SECURITY_ANSWER = 'auth/VALIDATE_SECURITY_ANSWER';
export const SET_SECURITY_ANSWER_STATUS = 'auth/SET_SECURITY_ANSWER_STATUS';
export const LOCK_USER = 'auth/LOCK_USER';
export const SET_LOCK_USER = 'auth/SET_LOCK_USER';
export const USER_SECURITY_QUESTIONS_ANSWER = 'auth/USER_SECURITY_QUESTIONS_ANSWER';
export const SET_USER_SECURITY_QUESTIONS_ANSWER = 'auth/SET_USER_SECURITY_QUESTIONS_ANSWER';
export const CONFIRM_UPDATE_USER_EMAIL = 'auth/CONFIRM_UPDATE_USER_EMAIL';
export const SET_UPDATE_USER_EMAIL = 'auth/SET_UPDATE_USER_EMAIL';
export const CONFIRM_USER_INFO = 'auth/CONFIRM_USER_INFO';

export const SET_USER_BY_ID = 'auth/SET_USER_BY_ID';
export const FETCH_USER_BY_ID = 'auth/FETCH_USER_BY_ID';

export const SET_GUEST_PERMISSION = 'auth/SET_GUEST_PERMISSION';
export const FETCH_GUEST_PERMISSION = 'auth/FETCH_GUEST_PERMISSION';
export const SET_USER_PERMISSION = 'auth/SET_USER_PERMISSION';
export const FETCH_USER_PERMISSION = 'auth/FETCH_USER_PERMISSION';

const SITE_OWNER = 'Site Owner';

export const authStore = {
  // namespaced: true,
  state: {
    initialized: false,
    loggedUser: null,
    registerUserInfo: null,
    confirmedUserName: null,
    confirmedUser: null,
    userserSecurityQuestions: null,
    userSecurityAnswerStatus: null,
    userserSecurityQuestionsAnswer: null,
    updateUserEmailResponse: null,
    userDetails: null,
    securityCodeResponse: null,
    userById: null,
    guestPermissions: null,
    userPermissions: null,
    userLockStatus: null,
    forceSecurityQuestionChange: null,
  },
  mutations: {
    markAuthStoreInitialized(state) {
      state.initialized = true;
    },
    [SET_LOGGED_USER](state, loggedUser) {
      state.loggedUser = loggedUser;
    },
    [SET_TOKENS](_, { accessToken, refreshToken }) {
      if (accessToken) {
        tokenStorage.setAccessToken(accessToken);
      } else {
        tokenStorage.removeAccessToken(null);
      }
      if (refreshToken) {
        tokenStorage.setRefreshToken(refreshToken);
      } else {
        tokenStorage.removeRefreshToken();
      }
    },
    [SET_CONFIRMED_USER_NAME](state, confirmedUserName) {
      state.confirmedUserName = confirmedUserName;
    },
    [SET_CONFIRMED_USER](state, confirmedUser) {
      state.confirmedUser = confirmedUser;
    },
    [CONFIRM_USER_INFO](state, userDetails) {
      state.userDetails = userDetails;
    },
    [SET_REGISTER_USER_INFO](state, registerUserInfo) {
      state.registerUserInfo = registerUserInfo;
    },
    [SET_USER_SECURITY_QUESTIONS](state, securityQuestions) {
      state.userserSecurityQuestions = securityQuestions;
    },
    [SET_USER_SECURITY_QUESTIONS_ANSWER](state, userserSecurityQuestionsAnswer) {
      state.userserSecurityQuestionsAnswer = userserSecurityQuestionsAnswer;
    },
    [SET_SECURITY_ANSWER_STATUS](state, securityAnsweStatus) {
      state.userSecurityAnswerStatus = securityAnsweStatus;
    },
    [SET_FORCE_SECURITY_QUESTION_CHANGE](state, forceSecurityQuestionChange) {
      state.forceSecurityQuestionChange = forceSecurityQuestionChange;
    },
    [SET_UPDATE_USER_EMAIL](state, updateUserEmailResponse) {
      state.updateUserEmailResponse = updateUserEmailResponse;
    },
    [SECURITY_CODE_RESPONSE](state, securityCodeResponse) {
      state.securityCodeResponse = securityCodeResponse;
    },
    [SET_USER_BY_ID](state, userById) {
      state.userById = userById;
    },
    [SET_GUEST_PERMISSION](state, guestPermissions) {
      state.guestPermissions = guestPermissions;
    },
    [SET_USER_PERMISSION](state, userPermissions) {
      state.userPermissions = userPermissions;
    },
    [SET_LOCK_USER](state, userLockStatus) {
      state.userLockStatus = userLockStatus;
    },
  },
  getters: {
    loggedUser: (state) => state.loggedUser,
    registerUserInfo: (state) => state.registerUserInfo,
    userserSecurityQuestions: (state) => state.userserSecurityQuestions,
    userSecurityAnswerStatus: (state) => state.userSecurityAnswerStatus,
    confirmedUserName: (state) => state.confirmedUserName,
    confirmedUser: (state) => state.confirmedUser,
    userDetails: (state) => state.userDetails,
    userserSecurityQuestionsAnswer: (state) => state.userserSecurityQuestionsAnswer,
    updateUserEmailResponse: (state) => state.updateUserEmailResponse,
    securityCodeResponse: (state) => state.securityCodeResponse,
    userById: (state) => state.userById,
    guestPermissions: (state) => state.guestPermissions,
    userPermissions: (state) => state.userPermissions,
    forceSecurityQuestionChange: (state) => state.forceSecurityQuestionChange,
  },
  actions: {
    [AUTH_INIT]: async ({ state, commit, dispatch }) => {
      /** Initialize the auth store: load essential data for the App to initialize */
      if (!state.initialized) {
        const refresToken = tokenStorage.getRefreshToken();
        const accessToken = tokenStorage.getAccessToken();
        if (refresToken && accessToken) {
          try {
            await dispatch(FETCH_LOGGED_USER);
          } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
              console.log('Tokens in the local storage are expired.');
              // remove tokens if needed
              // tokenStorage.removeRefreshToken();
              // tokenStorage.removeAccessToken();
            } else console.error(error); // some other error, network error ..
          }
        }
        /** Load permissions for the pages */
        if (state.loggedUser) {
          await dispatch(FETCH_USER_PERMISSION);
        } else {
          await dispatch(FETCH_GUEST_PERMISSION);
        }
        /** Mark the Auth Store as initialized:
         * this is to be initialized once for the App life cycle */
        commit('markAuthStoreInitialized');
      }
    },
    [SIGN_USER_IN]: async ({ commit }, payload) => {
      try {
        // commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        const { username, password } = payload;
        const resp = await login(username, password);
        const { access_token, refresh_token, forceSecurityQuestionChange } = resp.data;
        commit(SET_TOKENS, { accessToken: access_token, refreshToken: refresh_token });

        commit(SET_FORCE_SECURITY_QUESTION_CHANGE, { enable: forceSecurityQuestionChange });
      } catch (error) {
        commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        console.error('SIGN_USER_IN ERR', error.status);
        throw error;
      }
    },
    [SIGN_GUEST_IN]: async ({ commit }, payload) => {
      try {
        // commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        const { email } = payload;
        const resp = await guestin(email);
        const { access_token, refresh_token } = resp.data;
        commit(SET_TOKENS, { accessToken: access_token, refreshToken: refresh_token });
      } catch (error) {
        commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        console.error('SIGN_GUEST_IN ERR', error.status);
        throw error;
      }
    },
    [FETCH_LOGGED_USER]: async ({ commit }) => {
      try {
        const resp = await fetchLoggedUser();
        const { userId } = resp.data;
        const user = {
          id: userId,
          name: resp.data.userFullName,
          roles: resp.data.roles,
          email: resp.data.email,
          userName: resp.data.userName,
          isOwner: false,
          isForcePasswordChange: resp.data.forcePasswordChange,
          isSCCUser: resp.data.isSCCUser,
          isAnonymous: resp.data.isAnonymous,
          applicationPages: resp.data.applicationPages,
        };
        const respContactType = await getContactType(userId);
        if (respContactType.data.length > 0) {
          user.isOwner = !!respContactType.data.find((r) => r.contactType === SITE_OWNER);
        }
        commit(SET_LOGGED_USER, user);
      } catch (error) {
        commit(SET_LOGGED_USER, null);
        throw error;
      }
    },
    [SIGN_USER_OUT]: async ({ commit, dispatch }) => {
      try {
        const guestData = dispatch(FETCH_GUEST_PERMISSION);

        const refreshToken = tokenStorage.getRefreshToken();
        if (refreshToken) {
          logout(refreshToken);
        }
        commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        commit(SET_LOGGED_USER, null);

        return guestData;
      } catch (error) {
        console.error(error);
        commit(SET_LOGGED_USER, null);
        commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        if (error.status === 418) { throw new Error('Sorry, Something went wrong! Please try again later.'); }
      }
      return null;
    },
    [REFRESH_TOKENS]: async ({ commit }, refreshJwt) => {
      try {
        const resp = await refresh(refreshJwt);
        const { access_token, refresh_token } = resp.data;
        commit(SET_TOKENS, { accessToken: access_token, refreshToken: refresh_token });
      } catch (error) {
        commit(SET_TOKENS, { accessToken: null, refreshToken: null });
        commit(SET_LOGGED_USER, null);
        // throw error;
      }
    },
    [CONFIRM_REGISTER_USER_EMAIL]: async (_, payload) => {
      try {
        const { userName, rootURL } = payload;
        await confirmRegisterEmail(userName, rootURL);
      } catch (error) {
        console.error(`auth register_err:${error.Status}`);
        throw error;
      }
    },
    [VALIDATE_REGISTERATION_TOKEN]: async ({ commit }, payload) => {
      try {
        const { token } = payload;
        const resp = await validRegistrationToken(token);
        commit(SET_REGISTER_USER_INFO, resp.data);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [CONFIRM_USER_EMAIL]: async ({ commit }, payload) => {
      try {
        const { userName, rootURL, confirmType } = payload;
        // const resp = await confirmUserEmail(userName, rootURL, confirmType);
        return await confirmUserEmail(userName, rootURL, confirmType)
          .then((resp) => {
            commit(CONFIRM_USER_INFO, resp);
            return resp.data;
          })
          .catch((error) => {
            commit(CONFIRM_USER_INFO, error.status);
          });
        // commit(CONFIRM_USER_INFO, resp.data);
      } catch (error) {
        console.error(`CONFIRM_USER_EMAIL:${error.status}`);
        throw error;
      }
    },
    [VALIDATE_TEMP_TOKEN]: async ({ commit }, payload) => {
      try {
        const { tempToken } = payload;
        const resp = await validateTempToken(tempToken);
        commit(SET_TOKENS, { accessToken: resp.data.access_token, refreshToken: null });
        const { user } = resp.data;
        commit(SET_CONFIRMED_USER_NAME, user.userName);
        commit(SET_CONFIRMED_USER, user);
      } catch (error) {
        console.error('VALIDATE_TEMP_TOKEN error', error);
        throw error;
      }
    },
    [VALIDATE_SECURITY_CODE]: async ({ commit }, payload) => {
      try {
        const { securityCode } = payload;
        return await validateSecurityCode(securityCode)
          .then((resp) => {
            commit(SECURITY_CODE_RESPONSE, resp);
            commit(SET_TOKENS, { accessToken: resp.data.access_token, refreshToken: null });
            const { user } = resp.data;
            commit(SET_CONFIRMED_USER_NAME, user.userName);
            commit(SET_CONFIRMED_USER, user);
            return resp.data;
          })
          .catch((error) => {
            commit(SECURITY_CODE_RESPONSE, error.status);
          });
      } catch (error) {
        console.error('error', error);
        throw error;
      }
    },
    [VALIDATE_SECURITY_ANSWER]: async ({ commit }, { userId, securityQuestionId, answer }) => {
      try {
        commit(SET_SECURITY_ANSWER_STATUS, null);
        // console.log('VALIDATE_SECURITY_ANSWER', { userId, securityQuestionId, answer });
        await validateSecurityAnswer(userId, securityQuestionId, answer);
        commit(SET_SECURITY_ANSWER_STATUS, 'SUCCESS');
      } catch (error) {
        console.error(error);
        commit(SET_SECURITY_ANSWER_STATUS, 'FAILURE');
      }
    },
    [FETCH_USER_SECURITY_QUESTIONS]: async ({ commit }, payload) => {
      const { userId } = payload;
      const resp = await fetchUserSecurityQuestions(userId);
      // console.log('SecurityQuestions resp:', resp);
      const questions = resp.data.map((item) => ({
        question: item.securityQuestion.question,
        id: item.securityQuestion.id,
      }));
      commit(SET_USER_SECURITY_QUESTIONS, questions);
    },
    [USER_SECURITY_QUESTIONS_ANSWER]: async ({ commit }, payload) => {
      const { userId } = payload;
      const resp = await fetchUserSecurityQuestions(userId);
      commit(SET_USER_SECURITY_QUESTIONS_ANSWER, resp.data);
    },
    [LOCK_USER]: async ({ commit }, payload) => {
      try {
        const { userName } = payload;
        await lockUser(userName);
        commit(SET_LOCK_USER, 'SUCCESS');
      } catch (error) {
        console.log(error);
        commit(SET_LOCK_USER, 'FAILURE');
      }
    },
    [CONFIRM_UPDATE_USER_EMAIL]: async ({ commit }, payload) => {
      try {
        const { userId, newUserName, rootURL } = payload;
        return await updateUserEmail(userId, newUserName, rootURL)
          .then((resp) => {
            commit(SET_UPDATE_USER_EMAIL, 'SUCCESS');
            return resp.data;
          })
          .catch((error) => {
            console.error('CONFIRM_UPDATE_USER_EMAIL error', error);
            commit(SET_UPDATE_USER_EMAIL, 'FAILURE');
          });

        // await updateUserEmail(userId, newUserName, rootURL);
        // commit(SET_UPDATE_USER_EMAIL, 'SUCCESS');
      } catch (error) {
        console.error('CONFIRM_UPDATE_USER_EMAIL error', error);
        commit(SET_UPDATE_USER_EMAIL, 'FAILURE');
        throw error;
      }
    },
    [FETCH_USER_BY_ID]: async ({ commit }, payload) => {
      try {
        commit(SET_USER_BY_ID, null);
        const { userId } = payload;
        const resp = await getUserById(userId);
        commit(SET_USER_BY_ID, resp.data[0]);
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_USER_BY_ID, null);
        throw error;
      }
    },
    [FETCH_GUEST_PERMISSION]: async ({ commit }) => {
      try {
        commit(SET_GUEST_PERMISSION, { guestPermissions: null });
        return guestPermission()
          .then((resp) => {
            commit(SET_GUEST_PERMISSION, { guestPermissions: resp.data });
          })
          .catch((error) => {
            commit(SET_GUEST_PERMISSION, { guestPermissions: null });
            // console.error(`getguestpermission_err:${error.Status}`);
            throw error;
          });
      } catch (error) {
        commit(SET_GUEST_PERMISSION, { guestPermissions: null });
        // console.error(`getguestpermission_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_USER_PERMISSION]: async ({ commit }) => {
      try {
        commit(SET_USER_PERMISSION, { userPermissions: null });
        await userPermission()
          .then((resp) => {
            commit(SET_USER_PERMISSION, { userPermissions: resp.data });
          })
          .catch((error) => {
            console.error(error);
            commit(SET_USER_PERMISSION, { userPermissions: null });
          });
      } catch (error) {
        console.error(error);
        commit(SET_USER_PERMISSION, { userPermissions: null });
        throw error;
      }
    },
  },
};
